module.exports = "//static.hsappstatic.net/marketplace-ui-common/static-1.12016/img/storefront-header-blobs.svg"